(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('shadowItDiscovered', ["path", "securityEventsDao", "odometerFormat", function (path, securityEventsDao, odometerFormat) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('shadow-it/discovered').template('discovered'),
            scope: {
                saasList: '=',
                resolution: '=',
                updateSelectedSaas: '&'
            },
            link: function ($scope) {
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    return securityEventsDao.list().params({
                        groupBy: 'saas',
                        filterEnum_saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        }).join(','),
                        filterEnum_type: 'shadow_it',
                        afterColumn: 'create_time',
                        afterStep: $scope.resolution,
                        afterFromNow: true,
                        afterMax: 1
                    }).then(function (response) {
                        $scope.widgets = _($scope.saasList).map(function (saas) {
                            var found = _(response.data.rows).find(function (row) {
                                return row.saas == saas.name;
                            });
                            var discovered = found ? found.count : 0;
                            return {
                                title: 'Shadow-IT (' + saas.title + ')',
                                discovered: odometerFormat(discovered),
                                saas: saas
                            };
                        });
                    });
                };
                $scope.toggleShow = function (saas) {
                    saas.show = !saas.show;
                    var found = _($scope.saasList).find(function (saas) {
                        return saas.show;
                    });
                    if (!found) {
                        saas.show = true;
                    } else {
                        $scope.updateSelectedSaas();
                    }
                };
                $scope.$watch('resolution', function () {
                    $scope.widgetApi.reload();
                });
            }
        };
    }]);
}());